export var USER_VIEW_HISTORY_TIME_DECAY_KEY = 'ds-view-history-time-decay';
export var USER_VIEW_HISTORY_KEY = 'ds-view-history';
export var PURCHASE_HISTORY_KEY = 'ds-purchase-history';
export var CART_CONTENTS_KEY = 'ds-cart';